import { render, staticRenderFns } from "./EventsNavItems.vue?vue&type=template&id=fc6026fa&scoped=true&"
import script from "./EventsNavItems.vue?vue&type=script&lang=ts&"
export * from "./EventsNavItems.vue?vue&type=script&lang=ts&"
import style0 from "./EventsNavItems.vue?vue&type=style&index=0&id=fc6026fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc6026fa",
  null
  
)

export default component.exports